<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
            <v-row dense class="mb-5 text-center text-md-left subtitle-1">
                <v-col cols="12" lg="4">
                    <strong >Total remittance: <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{ alltotalremit | toNumberWithDecimal }}</strong>
                </v-col>
            </v-row>
          <v-row dense class="d-flex justify-end mt-n2">

            <v-col cols="12" lg="2" class="span-label" :class="($hideifuserisSupervisor())" v-if="$store.state.currentUser.agent_data.level == 0">
              <span>Coordinator</span>
              <!-- <agent-credit-autocomplete-template ref="agent_autocomplete"></agent-credit-autocomplete-template> -->
                <v-select 
                  clearable dense hide-details
                  v-model="filter.coordinator_id" 
                  :items="coordinatorlist"
                  item-value="id"
                  item-text="agentname"
                  label="Search agent"
                  class="regular-field"
                  ></v-select>
            </v-col>
            <!-- <v-col cols="12" lg="2" class="span-label" :class="($hideifuserisSupervisor())" v-if="$store.state.currentUser.agent_data.level == 0">
              <span v-html="$agentName"></span>
           
                <v-select 
                 clearable dense hide-details
                  v-model="filter.agent_id" 
                  :items="agentlist"
                  item-value="id"
                  item-text="agentname"
                  label="Search agent"
                  class="regular-field"
                  ></v-select>
            </v-col> -->

            <v-col cols="12" lg="2" class="span-label">
              <span>Draw</span>
              <v-select class="regular-field" dense clearable :items="drawlist" item-value="id" item-text="name" label="Draw" v-model="filter.draw_id" multiple>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">(+{{ filter.draw_id.length - 1 }})</span>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span>Date from</span>
              <v-text-field clearable dense hide-details class="regular-field" v-model="filter.datefrom" label="Date from" type="date"></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span>Date to</span>
              <v-text-field clearable dense hide-details class="regular-field" v-model="filter.dateto" label="Date to" type="date"></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn color="green_button" class="float-right btn-block" @click="datatable()">Search</v-btn>
            </v-col>

            <v-col cols="12" class="mt-2">
              <div class="table-responsive">
                <table class="table" id="users-table" style="color:white">
                  <thead>
                    <tr>
                      <td>Agent</td>
                      <td>Parent</td>
                      <td>Draw</td>
                      <td>Gross sales</td>
                      <td>Commission</td>
                      <td>Payout</td>
                      <td v-if="$store.state.currentUser.agent_data.level < 2 ">Win share</td>
                      <td>Total remit per draw</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(list) in remittance"
                      :key="list.id">
                    <td style="width: 200px">{{ list.manager }}</td>
                    <td style="width: 200px">{{ list.coordinator }}</td>
                    <td>
                      <div v-for="(item) in list.draws" :key="item.id">
                          <td style="border:0px">
                             {{ item.name }}
                          </td>
                      </div>
                      <div>
                        <td style="border:0px">
                          <b style="color:#F39C12;font-size:16px">Total</b>
                        </td>
                      </div>
                    </td>
                    <td>
                      <div v-for="(item) in list.draws" :key="item.id">
                          <td style="border:0px" >
                            <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{ item.totalsales == null ? '0.00' : item.totalsales | toCoin }}
                          </td>
                      </div>
                        <div>
                          <td style="border:0px">
                             <b style="color:#F39C12;font-size:16px">  <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{list.totalallgross | toCoin}}</b>
                          </td>
                      </div>
                    </td>
                    <td>
                      <div v-for="(item) in list.draws" :key="item.id">
                          <td style="border:0px">
                            <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{ item.totalcomi == null ? '0.00' : item.totalcomi | toCoin }}
                          </td>
                      </div>
                       <div>
                          <td style="border:0px">
                             <b style="color:#F39C12;font-size:16px">  <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{list.totalallcommi | toCoin}}</b>
                          </td>
                      </div>
                    </td>
                    <td>
                      <div v-for="(item) in list.draws" :key="item.id">
                          <td style="border:0px">
                             <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{ item.totalpayout == null ? '0.00' : item.totalpayout | toCoin }}
                          </td>
                      </div>
                      <div>
                          <td style="border:0px">
                             <b style="color:#F39C12;font-size:16px">  <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{list.totalallpayout | toCoin}}</b>
                          </td>
                      </div>
                    </td>
                    <td v-if="$store.state.currentUser.agent_data.level < 2 ">
                      <div v-for="(item) in list.draws" :key="item.id">
                          <td style="border:0px">
                             <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{ item.totalwinshare == null ?  '0.00' : item.totalwinshare | toCoin  }}
                          </td>
                      </div>
                       <div >
                          <td style="border:0px">
                             <b style="color:#F39C12;font-size:16px">  <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{list.totalallwinshare | toCoin}}</b>
                          </td>
                      </div>
                      
                    </td>
                    <td>
                      <div v-for="(item) in list.draws" :key="item.id">
                          <td style="border:0px">
                             <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{ item.totalremittance == null ? '0.00' : item.totalremittance | toCoin  }}
                          </td>
                      </div>
                     <div>
                          <td style="border:0px">
                             <b style="color:#F39C12;font-size:16px">   <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{list.totalallremit | toCoin}}</b>
                          </td>
                      </div>
                    </td>
                    </tr>
                   
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

  </section>
</template>

<script>
export default {
  data() {
    return {
      dt_headers: [],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      remittance: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      agentlist: [],
      coordinatorlist: [],
      filter: new this.$Form({
        draw_id: [],
        agent_id: null,
        coordinator_id: null,
        datefrom: this.$moment().format("YYYY-MM-DD"),
        dateto: this.$moment().format("YYYY-MM-DD"),
      }),
      drawlist: [],
      alltotalremit: 0,
    };
  },
  methods: {
    paramsfilter() {
      let subagent = this.$store.state.currentUser.agent_data.level;
      
      try {
        if (this.$refs.agent_autocomplete.autocomplete_model.id) {
          subagent = this.$refs.agent_autocomplete.autocomplete_model.id;
        }
      }catch (error){
        subagent = this.$store.state.currentUser.agent_data.level != 0 ? this.$store.state.currentUser.agent_data.id : null;
      }

      
      
      return {
        ...this.dt_options,
        query: this.dt_searchQuery,
        draw_id: this.filter.draw_id,
        datefrom: this.filter.datefrom,
        dateto: this.filter.dateto,
        agent_id: this.filter.agent_id,
        coordinator_id: this.filter.coordinator_id,
      };
    },
    async getDataFromApi() {
        this.dt_headers = [];
        let apival = null;
        if(this.$store.state.currentUser.agent_data.level == 0){
            apival = 'allremittance';
            this.dt_headers.push({ text: "Agent", value: "manager", name: "manager", sortable: false, searchable: false, });
            this.dt_headers.push({ text: "Coordinator", value: "coordinator", name: "coordinator", sortable: false, searchable: false, });
        }else{
            apival = 'agentremittance';
            this.dt_headers.push({ text: "Draw", value: "name", name: "name", sortable: false, searchable: false, })
        }

        

         if(this.$store.state.currentUser.agent_data.level == 0){
           this.dt_headers.push(
              { text: "Gross sales", value: "totalsales", name: "totalsales", sortable: false, searchable: false, },
              { text: "Commission", value: "totalcommi", name: "totalcommi", sortable: false, searchable: false, },
              { text: "Payout", value: "totalpayout", name: "totalpayout", sortable: false, searchable: false, },
              { text: "Win share", value: "totalwinshare", name: "totalwinshare", sortable: false, searchable: false, },
              { text: "Total remit", value: "totalremit", name: "totalremit", sortable: false, searchable: false, },
          );
        }else{
          this.dt_headers.push(
              { text: "Gross sales", value: "totalsales", name: "totalsales", sortable: false, searchable: false, },
              { text: "Commission", value: "totalcommi", name: "totalcommi", sortable: false, searchable: false, },
              { text: "Payout", value: "totalpayout", name: "totalpayout", sortable: false, searchable: false, },
              { text: "Total remit", value: "totalremit", name: "totalremit", sortable: false, searchable: false, },
          );
        }

        this.dt_loading = true;
        var paramsfilter = await this.paramsfilter();
        this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
        let params = await this.$YajraDT.params(
            paramsfilter,
            this.dt_options,
            this.dt_itemsPerPage,
            this.dt_columns
        );

        
        let apiPath = await this.$_CONFIG.api() + '/' + apival;

        await this.$axios
            .post(apiPath + "?" + this.$.param(params))
            .then((res) => {
            if (this.dt_totalResult != res.data.recordsFiltered) {
                this.dt_options.page = 1;
            }

            this.dt_resultlist = res.data.data;
            this.dt_totalResult = res.data.recordsFiltered;
            this.dt_loading = false;
            this.alltotalremit = res.data.alltotalremit;
            console.log(this.alltotalremit);
            })
            .catch((err) => {
            this.dt_loading = false;
            console.log("Error searching");
            });

        var unwatch = this.$watch(
            "dt_options.page",
            function(newValue, oldValue) {
            this.getDataFromApi();
            unwatch();
            },
            { deep: true }
        );
    },
    getdrawlist() {
      this.$axios
        .get(this.$_CONFIG.api("API_DRAW_DROPDOWN"))
        .then((res) => {
          this.drawlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    agentonly() {
      this.$axios
        .get(this.$_CONFIG.api() + "/v1/agentonlylist")
        .then((res) => {
          this.agentlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    coordinatoronly() {
      this.$axios
        .get(this.$_CONFIG.api() + "/v1/coordinatorlist")
        .then((res) => {
          this.coordinatorlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    swapArrayLocs(arr, index1, index2) {
        var temp = arr[index1];

        arr[index1] = arr[index2];
        arr[index2] = temp;
    },
    datatable() {
       this.apiconfig = null;
      if(this.$store.state.currentUser.agent_data.level == 1){
        this.filter.coordinator_id = this.$store.state.currentUser.agent_data.id;
        this.apiconfig = "/remittancepercoor";
      }else if(this.$store.state.currentUser.agent_data.level == 2){
        this.filter.coordinator_id = this.$store.state.currentUser.agent_data.id;
          this.apiconfig = "/remittanceperagent";
      }else{
        this.apiconfig = "/allremittance";
      }

      this.filter
        .post(this.$_CONFIG.api() + this.apiconfig)
        .then(({ data }) => {
          this.remittance = data.data;
          this.alltotalremit = data.total;
          })
        .catch(() => {});
    },
  },
  async created() {
    await this.datatable();
    await this.getdrawlist();
    await this.agentonly();
    await this.coordinatoronly();
  },
  mounted() {},
};
</script>
<style scoped></style>